// assets/store-locations.js
// @ts-nocheck


window.loadStoreLocations = async function (token, domain) {
    if (!token) throw new Error('Storefront API token mancante');
    if (!domain) throw new Error('Dominio Shopify mancante');

    try {
        const query = `
        query {
          locations(first: 250) {
            edges {
              node {
                id
                name
                address { formatted }
                metafield(namespace: "location", key: "data") {
                  reference {
                    ... on Metaobject {
                      id
                      fields {
                        key
                        value
                        reference {
                          ... on MediaImage {
                            image {
                              url
                              altText
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

        const res = await fetch(`https://${domain}/api/2024-10/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': token
            },
            body: JSON.stringify({ query })
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (data.errors) throw new Error(data.errors[0].message);

        // Mappa le locations
        const locations = data.data.locations.edges.map(edge => {
            const loc = edge.node;
            const meta = loc.metafield?.reference || null;
            const metaFields = {};

            if (meta?.fields) {
                meta.fields.forEach(f => {
                    if (f.reference && f.reference.image) {
                        metaFields[f.key] = f.reference.image.url;
                    } else {
                        metaFields[f.key] = f.value;
                    }
                });
            }

            return {
                id: loc.id,
                name: loc.name,
                shopifyAddress: loc.address?.formatted || "",
                title: metaFields.title || loc.name,
                slug: metaFields.slug || loc.name.toLowerCase().replace(/\s+/g, '-'),
                customAddress: metaFields.address || loc.address?.formatted,
                image: metaFields.image || null,
                phone: metaFields.phone || null,
                email: metaFields.email || null,
                hours: metaFields.hours || null
            };
        });

        return locations;

    } catch (err) {
        console.error('Errore nel caricamento delle locations:', err);
        return [];
    }
};
